<template>
  <div class="ml-5">
    <v-data-table
      item-key="id"
      :items-per-page="5"
      :headers="headers"
      :items="checks"
      loading-text="Đang Tải"
      no-data-text="Không có dữ liệu"
    >
      <template v-slot:[`item.type`]="{ item }">
        {{ item.type === 'refund' ? 'Hoàn trả' : 'Đối soát' }}
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>
      <template v-slot:[`item.currentAmount`]="{ item }">
        {{ formatMoney(item.data.currentAmount || 0) }}
      </template>
      <template v-slot:[`item.uploader`]="{ item }">
        {{ item.uploader.name }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    kind: String,
  },
  computed: {
    ...mapGetters({
      report: 'tuitionFeeReport/report',
      checks: 'tuitionFeeCheck/checks',
    }),
  },
  data() {
    return {
      histories: [],
      headers: [
        {
          text: 'Loại',
          value: 'type',
          align: 'left',
          sortable: false,
          width: '170px',
        },
        {
          text: 'Thời gian',
          value: 'createdAt',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Số tiền',
          value: 'currentAmount',
          align: 'right',
          sortable: false,
        },
        {
          text: 'Người upload',
          value: 'uploader',
          align: 'left',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    ...mapActions({
      fetchChecks: 'tuitionFeeCheck/fetch',
    }),
    formatDate(isoString) {
      return moment(isoString).format('HH:mm DD/MM/YYYY')
    },
    formatMoney(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
  watch: {
    report: {
      handler(val) {
        this.fetchChecks({ report: this.report._id, kind: this.kind })
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.divide {
  border: 0.2px solid rgb(196, 196, 196);
  margin: 4px 0;
}
</style>
